import { render, staticRenderFns } from "./suratEdaranAlasanReject.vue?vue&type=template&id=fe54019e&"
import script from "./suratEdaranAlasanReject.vue?vue&type=script&lang=js&"
export * from "./suratEdaranAlasanReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports